import { A, F } from '@mobily/ts-belt';
import { Box, Placeholder, Text } from '@stitch-fix/mode-react';
import styles from './styles.module.scss';

// Need `pt=125%` to display a placeholder with a 5:4 aspect ratio
const ProductCardPlaceholder = () => {
  return <Box mb={0.5} data-testid="product-card-placeholder">
      <Placeholder variant="rect" width="100%" mb={0.75} pt="125%" />
      <Box px={0.75}>
        <Text setting="body-small">
          <Placeholder width="60%" />
          <Placeholder width="90%" />
          <Placeholder width="30%" />
        </Text>
      </Box>
    </Box>;
};
const productCardPlaceholders = F.toMutable(A.makeWithIndex(60, index => <ProductCardPlaceholder key={index} />));

/**
 * The `ResultsPlaceholder` component renders loading placeholders for
 * UI elements rendered by the `ResultsLayout` component.
 * This includes the page subtitle, control menu, and 60 product cards.
 */
const ResultsPlaceholder = () => <>
    {/* Placeholder for subtitle "Based on your search..." */}
    <Text aria-label="loading results" setting="body-small">
      <Placeholder maxWidth={36} mx="auto" />
    </Text>

    {/* Placeholder for `ControlMenu` component */}
    <Placeholder variant="rect" height={2.5} width="100%" maxWidth={33.75} mx="auto" my={1.5} />

    {/* Placeholder for `Results` component */}
    <Box className={styles['product-placeholder-grid']}>
      {productCardPlaceholders}
    </Box>
  </>;
export default ResultsPlaceholder;